<template>
    <div class="df-inline-btn" v-if="!isViewOnly">
        <button class="btn btn-primary dfNavButton cancel df-save-and-continue-btn" name="saveType" type="button" value="ConfirmSubmitForm" @click.prevent="advanceForm">{{ buttonText }} &gt;</button>
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { useMainStore } from "@/mainStore";
import { computedAsync } from "@vueuse/core";
import { FormAlternativeSettings } from "@cs-ts/form-alternative-settings";
import type FormAlternativeDef from "../elements/FormAlternativeDef";
import { props, Props, components, setup } from "./BaseDefMixin.3";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<FormAlternativeDef, FormAlternativeSettings>) {
        const base = setup<FormAlternativeDef, FormAlternativeSettings>(props);

        const advanceForm = inject("advanceForm")!;
        const mainStore = useMainStore();

        const buttonText = computedAsync(async () => {
            if (base.pageStore.mustLogin && !(await mainStore.isLoggedInPromise)) {
                return base.settings.value.buttonTextWhenLoginRequired || "Log in to Start Form";
            } else {
                return base.settings.value.buttonText || "Start Form";
            }
        });

        return {
            buttonText,
            advanceForm,
            ...base.expose,
        };
    },
});
</script>
